import React from 'react'

import { Box, Button, CircularProgress, Typography } from "@mui/material";
import useClassCount from "../../../Infrastructure/CustomHooks/useClassCount";
import useGetClassDate from '../../../Infrastructure/CustomHooks/useGetClassDate';
import { convertTimestampToDay } from '../../../Infrastructure/Utilities/convertTimestampToDay';
import { classDetailsSx } from './styles';

export const ClassDetails = ({ classId, classDetails, isCoursePage, live, handleEnrolledCourse, convertToLocalStartTime, convertToLocalEndTime }) => {
  const { classCount, countLoading } = useClassCount(classId, live);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const { first_class, times, duration, max_learners } = classDetails;
  const { weekday, month, year } = useGetClassDate(first_class);

  const formattedTimes = [];
  const dayOrderMap = {
    'monday': 1,
    'tuesday': 2,
    'wednesday': 3,
    'thursday': 4,
    'friday': 5,
    'saturday': 6,
    'sunday': 7
  };

if (times && Object.keys(times).length > 0) {
  const dayTimeMap = {}
  Object.entries(times).forEach(([day, { start, end }]) => {
    const formattedStart = convertToLocalStartTime(start, timezone);
    const formattedEnd = convertToLocalEndTime(end, timezone);
    const dayName = convertTimestampToDay(day)
    const timeRange = `${formattedStart} - ${formattedEnd}`;
    if (!dayTimeMap[dayName]) {
      dayTimeMap[dayName] = [];
    }
    dayTimeMap[dayName].push(timeRange);
  })

  // Turn into array like [day, "time1 - time2, time3 - time4"]
  Object.entries(dayTimeMap).forEach(([dayName, timesArray]) => {
    const capitalizedDay = dayName.charAt(0).toUpperCase() + dayName.slice(1);
    formattedTimes.push([capitalizedDay, timesArray.join(', ')]);
  })

  formattedTimes.sort(([dayA], [dayB]) => {
    return dayOrderMap[dayA.toLowerCase()] - dayOrderMap[dayB.toLowerCase()];
  });
}

  return (
    <Box key={classId} sx={classDetailsSx.containerBox}>
      <Box sx={classDetailsSx.infoBox}>
        <Typography textTransform={'capitalize'} variant="h6" color={'primary'} sx={classDetailsSx.startDateText}>
        Start Date: <span style={classDetailsSx.startDateValue}>{month}/{weekday}/{year}</span>
        </Typography>
        {formattedTimes.length > 0 ? (
        formattedTimes.map((time, index) => (
          <Box textTransform={'capitalize'} key={index}>
            <Typography component="span" sx={classDetailsSx.dayText} variant="h6">
              {time[0]}
            </Typography>
            :
            <Typography component="span" sx={classDetailsSx.timeText} variant="h6">
            {" "}{time[1]}
            </Typography>
          </Box>
            ))
          ) : (
            <Typography variant="h6" sx={classDetailsSx.noScheduleText}>
              No schedule available
            </Typography>
          )}
          <Typography variant="h6" sx={classDetailsSx.durationText}>
              Duration
              <Typography component="span" sx={classDetailsSx.durationValue} variant="h6">
                 {/* eslint-disable-next-line eqeqeq */}
                 :{" "}{duration} {duration == "1" ? "Week" : "Weeks"}
              </Typography>
          </Typography>
      </Box>
      <Box sx={classDetailsSx.actionBox}>

        {isCoursePage ? (countLoading ? (
          <CircularProgress />
        ) : classCount === max_learners ? (
          <Typography color="initial" sx={classDetailsSx.classFullText}>Class Full</Typography>
        ) : (
          <Button
            variant="contained"
            color="primary"
            sx={{
              '&:hover': {
                cursor: live ? 'pointer' : 'not-allowed',
              },
              pointerEvents: live ? 'auto' : 'none',
            }}
            onClick={() => handleEnrolledCourse(classId)}
          >
            Enroll Now
          </Button>
        )
        ) : (
          <Button
            variant="contained"
            color="primary"
            sx={{
              '&:hover': {
                cursor: live ? 'pointer' : 'not-allowed',
              },
              pointerEvents: live ? 'auto' : 'none',
            }}
          >
            Enroll Now
          </Button>
        )}

      </Box>
    </Box>
  );
};